import React from 'react';
import { Helmet } from "react-helmet-async";
import { useI18n } from "../../i8n/useI18n";
import CartSection from "../sections/cart/overview/CartSection";

const CartPage = () => {
    const { t } = useI18n();

    return (
        <>
            <Helmet>
                <title>{t("cartPage.title")} | {t("brand.name")}</title>
            </Helmet>
            <CartSection />
        </>
    );
};

export default CartPage;
